import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'mirron',
  title1: 'mirron',
  introduction_text:
    'アフリカ向けアプリを開発いたしました。このアプリは、デジタルを活用したユーザー接点の展開のためのものです。弊社はデジタルトランスフォーメーションを推進するため、ワークショップの開催からサービス開発までを支援を実施しました。',
  company: '大手化学メーカー',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'PdM/PMM体制実行支援',
  tag2src: '/cases/pdm-pmm/',
  industryTagText: 'メーカー/製造/建設',
  industryTagSrc: '/cases/manufacturing/',
  color: '',
  background: '#FAECE3',
  staff1: '',
  image: '/images/img/cases/caseStudyTop/mirron.webp',
  alt: 'mirron',
  imgClass: 'fv_img_adjust1',
}

// プロジェクト概要
export const overviewTitle = 'デジタルトランスフォーメーション推進の伴走支援'
export const overviewItem: OverviewItems[] = [
  {
    text: 'サハラ砂漠以南のサブサハラアフリカでは、現地の女性向け美容において付け毛ヘアーは重要な役割を担っています。この市場でシェアをもつクライアントは、メーカーとしての川上のビジネスだけでなく、ユーザー接点をデジタルを使って展開できないかと考えていました。Aitriaでは同社のデジタルトランスフォーメーションを推進するためのワークショップの開催から、実際のサービス開発まで支援しています。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '事業拡大の計画はあるが、プロセスが不明瞭',
        text: '',
      },
      {
        title: 'デジタルを活用したユーザー接点の強化ができていない',
        text: '',
      },
      {
        title: '現地でのマーケティング活動の知見が不足',
        text: '',
      },
    ],
    solutions: [
      {
        title: 'ワークショップを開催し、サービスアイデアを創出',
        text: '',
      },
      {
        title: 'デジタル接点の知見を活かしたアイデアの具現化',
        text: '',
      },
      {
        title: '企画、開発、グロース支援まで数年単位の伴走支援',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
